export default "__VITE_ASSET__CZ1TxCGN__"